<script>
	import DalleLoader from '../../molecules/DalleLoader/DalleLoader.svelte';
	import {currentDalleImages} from '../../../store';

	import Icon from '../../atoms/Icon.svelte';
	import info from '../../../../public/assets/svg/14/info.svg';

	async function fetchImageCreationAIs() {	
		const dalle = fetch(`https://originea-api.fly.dev/dalle/${encodeURIComponent(query)}`);
		const stability = fetch(`https://originea-api.fly.dev/stability/${encodeURIComponent(query)}`);

		return Promise.all([dalle, stability])
		.then(async ([dalleRes, stabilityRes]) => {
			const dalleData = await dalleRes.json();
			const stabilityData = await stabilityRes.json();
			return [...dalleData, ...stabilityData]
		}).then(response => {
			json = response;
			$currentDalleImages.query = query;
			$currentDalleImages.images = json;
		}).catch(error => {
			console.log(error);
		})
	}
	
	export let query = '';
	export let step = '';
	export let selectedImage = '';

	let promise = "";
	let json = $currentDalleImages.images || [];
	let selectedImageIndex = $currentDalleImages.currentlySelected || 0;	
	
	$: if(json.length) selectedImage = json[selectedImageIndex];
	
	// only fetch dalle again if query/title has changed
    $: if(query !== $currentDalleImages.query) promise = fetchImageCreationAIs();

	// set currentlySelected in store based on local variable selectedImageIndex
	$: $currentDalleImages.currentlySelected = selectedImageIndex;
	
</script>
<div class="DalleSelector">
	{#await promise}
		<div class="DalleSelector__loader">
			<DalleLoader></DalleLoader>
		</div>
	{:then val}
		{#if json.length}
		<p class="DalleSelector__label">Choose an image</p>
		<ul>
			{#each json as entry, index}
				<li>
					<input id={`dalleImg${index}`} type="radio" name="dalle_image" bind:group={selectedImageIndex} value={index}>
					<label for={`dalleImg${index}`}>
						<img src={`data:image/webp;base64,${entry?.b64Data}`} alt={query}>
					</label>
				</li>
			{/each}	
		</ul>
		<span class="DalleSelector__info">
			<Icon data={info} size={'14px'} fill="#EDF22C" stroke="#341153" viewBox='0 0 14 14'></Icon>
			<small>Bad results? Refine your title or image prompt.</small>
		</span>
		<div class="btn__group">
			<button class="btn btn--primary is-light" type="button" on:click={() => step = 4}>Next</button>
			<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => step = 2}>Back</button>
		</div>
		{:else}
			<p class="DalleSelector__error">No images found. Try again.</p>
			<div class="btn__group">
				<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => step = 2}>Back</button>
			</div>
		{/if}	
	{:catch error}
		<p class="DalleSelector__error">Something went wrong. Please try again.</p>
		<div class="btn__group">
			<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => step = 2}>Back</button>
		</div>
	{/await}
</div>

<style lang="scss" src="./DalleSelector.scss"></style>